import functions from "./functions.js";

$(function() {

    const $form = $('.form-contact');
    const form = $form[0];

    if ( !form ) {
        return;
    }

    $form.on('submit', e => {

        e.preventDefault();

        $(".fa-spinner").removeClass('d-none');

        let values = {};
        $.each($form.serializeArray(), function(i, field) {
            values[field.name] = field.value;
        });
        values['language'] = functions.getLang();
        grecaptcha.ready(function() {
            grecaptcha.execute('6LeAz5gUAAAAAKoZP6-NVwB5wTFGjyeCVGmm582z', {action: 'contact'}).then(function(token) {
                values['gRecaptchaToken'] = token;

                $.post('/services/contact/', values).then(response => {
                    response = JSON.parse(response);
                    $(".response-output").html(response.data);
                    $(".response-output").removeClass('d-none');
                    $(".fa-spinner").addClass('d-none');
                });
            });
        });
     });
});